export function checkStorageValue (value) {
  return ['true', 'false'].indexOf(value) >= 0 ? JSON.parse(value) : value;
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/checkStorageValue.js
// module id = 842
// module chunks = 2